import { FC, useState } from "react";
import { CustomLineItem } from "src/types/ctgraphql.d";
import {
  getCustomLineItemDataTestid,
  getCustomLineItemDescriptionTranslation,
  getCustomLineItemLabelTranslation,
} from "./utils";
import { Box, Flex } from "@otrium/core";
import { useLingui } from "@lingui/react";
import { InfoCircleIcon } from "src/icons";
import { CTPrice } from "src/atoms/CTPrice";
import { AlertBanner } from "@otrium/atoms";
import { IconButton } from "src/atoms/IconButton";
import { useTheme, Theme } from "@emotion/react";
import { msg } from "@lingui/macro";

const SummaryCustomLineItem: FC<{
  dataTestIdPrefix?: string;
  customLineItem: CustomLineItem;
}> = ({ dataTestIdPrefix = "", customLineItem }) => {
  const { _ } = useLingui();
  const [isAlertBannerVisible, setIsAlertBannerVisible] =
    useState<boolean>(false);

  const theme: Theme = useTheme();

  const { slug, totalPrice, name } = customLineItem;
  const descriptionTransKey = name
    ? msg`summary.customs_fee_description`
    : getCustomLineItemDescriptionTranslation(slug);
  const dataTestid = getCustomLineItemDataTestid(slug);

  return (
    <Flex
      flexDirection="column"
      flex={1}
      {...(dataTestid
        ? { "data-testid": `${dataTestIdPrefix}${dataTestid}` }
        : {})}
    >
      <Flex justifyContent="space-between" alignItems="center">
        <Flex alignItems="center">
          <Box>{name || _(getCustomLineItemLabelTranslation(slug))}</Box>

          {(name || descriptionTransKey) && (
            <Box>
              <IconButton
                aria-label="Info Button"
                onClick={() => setIsAlertBannerVisible(!isAlertBannerVisible)}
                sx={{
                  padding: theme.space.space4,
                  width: theme.space.space24,
                  height: theme.space.space24,
                }}
              >
                <InfoCircleIcon
                  width={theme.space.space16}
                  height={theme.space.space16}
                />
              </IconButton>
            </Box>
          )}
        </Flex>
        <Box
          {...(dataTestid
            ? { "data-testid": `${dataTestIdPrefix}${dataTestid}-price` }
            : {})}
        >
          <CTPrice price={totalPrice} />
        </Box>
      </Flex>
      {isAlertBannerVisible && descriptionTransKey ? (
        <Box mt={2}>
          <AlertBanner variant="info">{_(descriptionTransKey)}</AlertBanner>
        </Box>
      ) : null}
    </Flex>
  );
};

export default SummaryCustomLineItem;
